import { NAME_DOCUMENT_FOR_GAME_INFOR, ENUM_STATUS_GAME } from "constants"

import React, { useState } from "react"

import BoxButton from "components/BoxButton"
import CustomButton from "components/CustomButton"
import { updateDocument } from "firebase-helper/firestore-services"
import { AiOutlineLink, AiOutlineCopy } from "react-icons/ai"
import { GrUserAdmin, GrUser } from "react-icons/gr"
import { RiSkullLine, RiUser5Line } from "react-icons/ri"
import { randomNumber, copyToClipboard, showNotification } from "utils"

const Wait = ({ room, users, user }) => {
    const [whoSetShadow, setWhoSetShadow] = useState(0) // 0 : me 1:competitor

    const handleSetup = async() => {
        if (users.length !== 2){
            showNotification("error", "Phòng chưa đủ 2 người chưa thể bắt đầu", {
                autoClose: 2999
            })

            return
        }
        const num1 = randomNumber(1, 9999999)
        let seri1 = `${num1}`
        seri1 = Array.from(new Array(7 - seri1.length), (val) => "0") + seri1

        const num2 = randomNumber(1, 9999999)
        let seri2 = `${num2}`
        seri2 = Array.from(new Array(7 - seri2.length), (val) => "0") + seri2

        await updateDocument(NAME_DOCUMENT_FOR_GAME_INFOR, room.id, {
            status            : ENUM_STATUS_GAME.SET_SHADOW,
            userid_set_shadow : whoSetShadow === 0 ? users[0].id : users[1].id,
            series            : [seri1, seri2]
        })
    }

    const handleCopy = () => {
        const result = copyToClipboard(room.id)
        if (result){
            showNotification("success", "Bạn yêu đã copy Room ID thành công ^^", {
                autoClose: 1998
            })
        }
    }

    const handleCopyLink = () => {
        const result = copyToClipboard(window.location.href)
        if (result){
            showNotification("success", "Bạn yêu đã copy link Room thành công ^^", {
                autoClose: 1998
            })
        }
    }

    return (
        <>
            <p className="text-xl font-bold tracking-wide text-center">PHÒNG: { room.name }</p>

            <p className="text-xl font-bold tracking-wide text-center mt-1">ID: { room.id }</p>

            <div className="flex-center gap-3 flex-wrap">
                <div
                    className="bg-primary--light hover:bg-primary hover:text-black cursor-pointer rounded-full flex-center h-[32px] w-[32px] text-white"
                    onClick={ handleCopy }
                >
                    <AiOutlineCopy />
                </div>

                <div
                    className="bg-primary--light hover:bg-primary hover:text-black cursor-pointer rounded-full flex-center h-[32px] w-[32px] text-white"
                    onClick={ handleCopyLink }
                >
                    <AiOutlineLink />
                </div>
            </div>

            <div className="mt-6">
                <p className="text-lg font-semibold">Thành viên</p>

                <div className="flex mt-2 space-x-4">
                    { users.map((user, index) => (
                        <div className="flex flex-col items-center justify-center" key={ user.id }>
                            <div
                                className={ `${
                                    index === 0 ? "bg-[#d0d3d6]" : "bg-border"
                                } p-4 rounded-full` }
                            >
                                { index === 0 ? <GrUserAdmin size={ 20 } /> : <GrUser size={ 20 } /> }
                            </div>

                            <p>{ user.name }</p>
                        </div>
                    )) }
                </div>
            </div>

            { users[0].id === user.id && (
                <>
                    <div className="mt-8">
                        <p className="text-lg font-semibold">Ai là người giao bóng</p>

                        <div className="flex mt-2 space-x-3">
                            <BoxButton
                                className={ `${
                                    whoSetShadow === 0
                                        ? "bg-primary--light text-white border-0"
                                        : ""
                                }` }
                                icon={ <RiUser5Line size={ 24 } /> }
                                title="Tôi"
                                onClick={ () => setWhoSetShadow(0) }
                            />

                            <BoxButton
                                className={ `${
                                    whoSetShadow === 1
                                        ? "bg-primary--light text-white border-0"
                                        : ""
                                }` }
                                icon={ <RiSkullLine size={ 24 } /> }
                                title="Đối phương"
                                onClick={ () => setWhoSetShadow(1) }
                            />
                        </div>
                    </div>

                    <CustomButton className="w-full h-[44px] mt-10" onClick={ handleSetup }>
                        Giao bóng
                    </CustomButton>
                </>
            ) }
        </>
    )
}

export default Wait
